import { useNavigate } from "react-router-dom"
import { JobItem } from "../jobItem"
import { LoadingComponent } from "../loading"
import { JobListComponentProps } from "./model"

export const JobList = (jobsProps: JobListComponentProps) => {
    const navigate = useNavigate()
    const onItemClick = (jobId: string) => {
        navigate(`/job/${jobId}`)
    }

    if (jobsProps.loading) {
        return <div><LoadingComponent /></div>
    }

    return (
        <div className="w-full">
            {jobsProps.jobs && jobsProps.jobs.length > 0
                ? jobsProps.jobs.map((item) => (
                    <JobItem
                        key={item.id}
                        id={item.id}
                        title={item.gigTitle}
                        thumbnail={item.images?.[0] ?? item.thumbnail}
                        location={item.location}
                        startDate={item.dateFrom}
                        rate={item.rate}
                        rateType={item.rateType}
                        status={item.enabled}
                        dateTo={item.dateTo}
                        eventId={item.eventId}
                        eventName={item.eventName}
                        onClickAction={() => onItemClick(item.id)}
                        onChanged={jobsProps.onChanged}
                    />
                ))
                : <p className="text-figmaDarkGray text-[14px] text-center mt-[32px]">Nu există joburi.</p>
            }
        </div>
    )
}